"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = GLWBPageTwo;
var _react = _interopRequireWildcard(require("react"));
var _formik = require("formik");
var _EditableCompetitorTable = _interopRequireDefault(require("./EditableCompetitorTable"));
var _StaticCompetitorTable = _interopRequireDefault(require("./StaticCompetitorTable"));
var _GuaranteedLifetimeWithdrawalBenefitWizardCalc = require("./GuaranteedLifetimeWithdrawalBenefitWizardCalc.config");
var _reactBlueprintLibrary = require("react-blueprint-library");
var _RetirePayInfoTable = require("./RetirePayInfoTable");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function GLWBPageTwo(_ref) {
  var {
    setIsEditable,
    isEditable
  } = _ref;
  var {
    values: {
      glwbVersion,
      isSingleLife,
      isNewYork
    },
    values,
    setFieldValue
  } = (0, _formik.useFormikContext)();
  var [snapshot, setSnapshot] = (0, _react.useState)([]);
  var [showToast, setShowToast] = (0, _react.useState)(false);
  var [hasCompetitorDataChanged, setHasCompetitorDataChanged] = (0, _react.useState)(false);

  // Initialize arrowUpOrDown based on openToStart prop
  var [arrowUpOrDown, setArrowUpOrDown] = (0, _react.useState)(openToStart ? 'up' : 'down');
  var arrowUpOrDownCode = arrowUpOrDown === 'up' ? '0' : '';

  // Handle arrow direction on click (i.e. this will flip the arrow(s)/chevron(s) up and down)
  var handleItemClick = eventKey => () => {
    setArrowUpOrDown(eventKey === 'up' ? 'down' : 'up');
  };
  var arraySelection = 'singleLifeArray';
  var retirePayInfoTable = '';
  var infoTableVersion = '';
  var openToStart = '';
  var currentRatesText = '';
  if (isSingleLife === 'singleLife' && isNewYork === 'otherState') {
    ;
    arraySelection = 'singleLifeArray', infoTableVersion = 'Non-New York Single Life';
    currentRatesText = 'Current single life withdrawal rates for contracts not issued in New York. Learn more about how the RetirePay withdrawal rate table works.';
    retirePayInfoTable = /*#__PURE__*/_react.default.createElement(_RetirePayInfoTable.SingleLifeNonNewYorkInfo, null);
  } else if (isSingleLife === 'jointLife' && isNewYork === 'otherState') {
    ;
    arraySelection = 'jointLifeArray', infoTableVersion = 'Non-New York Joint Life';
    currentRatesText = 'Current joint life withdrawal rates for contracts not issued in New York. Learn more about how the RetirePay withdrawal rate table works.';
    retirePayInfoTable = /*#__PURE__*/_react.default.createElement(_RetirePayInfoTable.JointLifeNonNewYorkInfo, null);
  } else if (isSingleLife === 'singleLife' && isNewYork === 'newYork') {
    ;
    arraySelection = 'nySingleArray', infoTableVersion = 'New York Single Life';
    currentRatesText = 'Current single life withdrawal rates for contracts issued in New York. Learn more about how the RetirePay withdrawal rate table works.';
    retirePayInfoTable = /*#__PURE__*/_react.default.createElement(_RetirePayInfoTable.SingleLifeNewYorkInfo, null);
  } else if (isSingleLife === 'jointLife' && isNewYork === 'newYork') {
    ;
    arraySelection = 'nyJointArray', infoTableVersion = 'New York Joint Life';
    currentRatesText = 'Current joint life withdrawal rates for contracts issued in New York. Learn more about how the RetirePay withdrawal rate table works.';
    retirePayInfoTable = /*#__PURE__*/_react.default.createElement(_RetirePayInfoTable.JointLifeNewYorkInfo, null);
  }
  (0, _react.useEffect)(() => {
    if (isEditable) {
      setFieldValue(snapshot.arraySelection, snapshot.value);
      var temp = {
        arraySelection: arraySelection,
        value: values[arraySelection]
      };
      setSnapshot(temp);
    }
  }, [glwbVersion]);

  // Auto-focus to snap scrolling to top of the stepper/progress bar if user travels back-and-forth between steps
  (0, _react.useEffect)(() => {
    document.getElementById(_GuaranteedLifetimeWithdrawalBenefitWizardCalc.calcName).scrollIntoView();
    /* istanbul ignore else */
    if (window) {
      window.scrollBy(0, -112);
    }
    setFieldValue('hasNavigatedPage', true);
  }, []);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Tabs, {
    defaultKey: "1",
    id: "default-basic-example-tabnav",
    onSelect: null
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Tabs.Tab, {
    eventKey: "1",
    title: "Sample Competitor",
    "aria-label": "sample_competitor_tab"
  }, isEditable ? /*#__PURE__*/_react.default.createElement(_EditableCompetitorTable.default, {
    setIsEditable: setIsEditable,
    arraySelection: arraySelection,
    setSnapshot: setSnapshot,
    setShowToast: setShowToast,
    showToast: showToast,
    setHasCompetitorDataChanged: setHasCompetitorDataChanged,
    hasCompetitorDataChanged: hasCompetitorDataChanged
  }) : /*#__PURE__*/_react.default.createElement(_StaticCompetitorTable.default, {
    setIsEditable: setIsEditable,
    arraySelection: arraySelection,
    setSnapshot: setSnapshot,
    setShowToast: setShowToast,
    showToast: showToast
  })), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Tabs.Tab, {
    eventKey: "2",
    title: "MassMutual RetirePay",
    "aria-label": "massmutual_retirepay_tab"
  }, currentRatesText, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Collapse, {
    defaultActiveKey: arrowUpOrDownCode,
    className: "glwb-info-collapse view-more-retirepay"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Collapse.Group, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Collapse.Toggle, {
    eventKey: "0",
    open: arrowUpOrDownCode === '0' ? true : false,
    onClick: handleItemClick(arrowUpOrDown)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "retirepay-info-collapse-text"
  }, arrowUpOrDownCode === '0' ? 'View less' : 'View more')), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Collapse.Collapse, {
    eventKey: "0"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-spacing--minor"
  }, "Unlike traditional GLWBs, RetirePay's roll-up is built into the withdrawal rate table. The withdrawal rate increase in two ways:", /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", {
    className: "mm-spacing--none"
  }, "It increases with each year that taking income is deferred."), /*#__PURE__*/_react.default.createElement("li", null, "When a new age band on the table is reached."))), "The benefit base can grow with step-ups due to positive market performance. And, since the roll-up is built into the withdrawal rate and not the benefit base - and RetirePay fees are assessed on the benefit base - your clients may benefit from an overall lower fee."))), /*#__PURE__*/_react.default.createElement("div", {
    className: "content"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card.Body, {
    className: "zircon-background"
  }, /*#__PURE__*/_react.default.createElement("h3", {
    className: "glwb retirepay-table-title mm-text-center"
  }, "MassMutual RetirePay"), /*#__PURE__*/_react.default.createElement("p", {
    className: "glwb retirepay-table-version-text mm-text-center"
  }, infoTableVersion), retirePayInfoTable))))));
}